// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App Navigation Button Container */
.app-nav-container {
  position: relative;
  display: inline-block;
}

/* Main Navigation Button */
.app-nav-button {
  background: transparent;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  padding: 8px;
}

.app-nav-button:hover {
  background-color: rgba(60, 64, 67, 0.08);
}

.app-nav-button:active {
  background-color: rgba(60, 64, 67, 0.12);
}

/* 3x3 Grid of Dots */
.app-nav-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  gap: 2px;
  width: 18px;
  height: 18px;
}

.nav-dot {
  width: 4px;
  height: 4px;
  background-color: #5f6368;
  border-radius: 50%;
}

.app-nav-button:hover .nav-dot {
  background-color: #202124;
}

/* Dropdown Menu */
.app-nav-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #dadce0;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  min-width: 320px;
  z-index: 1000;
  margin-top: 8px;
  overflow: hidden;
}

/* Dropdown Header */
.app-nav-header {
  padding: 16px 20px 12px 20px;
  border-bottom: 1px solid #e8eaed;
  background: #f8f9fa;
}

.app-nav-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #202124;
}

/* App Grid Container */
.app-nav-grid-container {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Individual App Item */
.app-nav-item {
  display: flex;
  align-items: center;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  position: relative;
  border: 1px solid transparent;
}

.app-nav-item:hover {
  background-color: #f1f3f4;
}

.app-nav-item.current {
  background-color: #e8f0fe;
  border-color: #1976d2;
}

.app-nav-item.current:hover {
  background-color: #e3f2fd;
}

/* App Icon */
.app-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  margin-right: 12px;
  flex-shrink: 0;
}

/* App Information */
.app-info {
  flex: 1 1;
  min-width: 0;
}

.app-name {
  font-size: 14px;
  font-weight: 500;
  color: #202124;
  margin-bottom: 2px;
}

.app-description {
  font-size: 12px;
  color: #5f6368;
  line-height: 1.3;
}

/* Current App Indicator */
.current-indicator {
  position: absolute;
  top: 8px;
  right: 8px;
  color: #1976d2;
  font-size: 8px;
}

/* Dropdown Footer */
.app-nav-footer {
  padding: 12px 20px;
  border-top: 1px solid #e8eaed;
  background: #f8f9fa;
  text-align: center;
}

.app-nav-footer small {
  color: #5f6368;
  font-size: 11px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .app-nav-dropdown {
    right: -10px;
    min-width: 280px;
  }
  
  .app-nav-button {
    width: 36px;
    height: 36px;
  }
  
  .app-nav-grid {
    width: 16px;
    height: 16px;
  }
  
  .nav-dot {
    width: 3px;
    height: 3px;
  }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .app-nav-dropdown {
    background: #2d3748;
    border-color: #4a5568;
    color: #e2e8f0;
  }
  
  .app-nav-header {
    background: #1a202c;
    border-bottom-color: #4a5568;
  }
  
  .app-nav-header h3 {
    color: #e2e8f0;
  }
  
  .app-nav-item:hover {
    background-color: #4a5568;
  }
  
  .app-nav-item.current {
    background-color: #2b6cb0;
    border-color: #3182ce;
  }
  
  .app-name {
    color: #e2e8f0;
  }
  
  .app-description {
    color: #a0aec0;
  }
  
  .app-nav-footer {
    background: #1a202c;
    border-top-color: #4a5568;
  }
  
  .app-nav-footer small {
    color: #a0aec0;
  }
  
  .nav-dot {
    background-color: #a0aec0;
  }
  
  .app-nav-button:hover .nav-dot {
    background-color: #e2e8f0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AppNavigationButton.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,aAAa;AACb;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,cAAc;EACd,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,UAAU;IACV,WAAW;EACb;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* App Navigation Button Container */\n.app-nav-container {\n  position: relative;\n  display: inline-block;\n}\n\n/* Main Navigation Button */\n.app-nav-button {\n  background: transparent;\n  border: none;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease;\n  padding: 8px;\n}\n\n.app-nav-button:hover {\n  background-color: rgba(60, 64, 67, 0.08);\n}\n\n.app-nav-button:active {\n  background-color: rgba(60, 64, 67, 0.12);\n}\n\n/* 3x3 Grid of Dots */\n.app-nav-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-template-rows: repeat(3, 1fr);\n  gap: 2px;\n  width: 18px;\n  height: 18px;\n}\n\n.nav-dot {\n  width: 4px;\n  height: 4px;\n  background-color: #5f6368;\n  border-radius: 50%;\n}\n\n.app-nav-button:hover .nav-dot {\n  background-color: #202124;\n}\n\n/* Dropdown Menu */\n.app-nav-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background: white;\n  border: 1px solid #dadce0;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n  min-width: 320px;\n  z-index: 1000;\n  margin-top: 8px;\n  overflow: hidden;\n}\n\n/* Dropdown Header */\n.app-nav-header {\n  padding: 16px 20px 12px 20px;\n  border-bottom: 1px solid #e8eaed;\n  background: #f8f9fa;\n}\n\n.app-nav-header h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 500;\n  color: #202124;\n}\n\n/* App Grid Container */\n.app-nav-grid-container {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* Individual App Item */\n.app-nav-item {\n  display: flex;\n  align-items: center;\n  padding: 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  position: relative;\n  border: 1px solid transparent;\n}\n\n.app-nav-item:hover {\n  background-color: #f1f3f4;\n}\n\n.app-nav-item.current {\n  background-color: #e8f0fe;\n  border-color: #1976d2;\n}\n\n.app-nav-item.current:hover {\n  background-color: #e3f2fd;\n}\n\n/* App Icon */\n.app-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  margin-right: 12px;\n  flex-shrink: 0;\n}\n\n/* App Information */\n.app-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.app-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #202124;\n  margin-bottom: 2px;\n}\n\n.app-description {\n  font-size: 12px;\n  color: #5f6368;\n  line-height: 1.3;\n}\n\n/* Current App Indicator */\n.current-indicator {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  color: #1976d2;\n  font-size: 8px;\n}\n\n/* Dropdown Footer */\n.app-nav-footer {\n  padding: 12px 20px;\n  border-top: 1px solid #e8eaed;\n  background: #f8f9fa;\n  text-align: center;\n}\n\n.app-nav-footer small {\n  color: #5f6368;\n  font-size: 11px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .app-nav-dropdown {\n    right: -10px;\n    min-width: 280px;\n  }\n  \n  .app-nav-button {\n    width: 36px;\n    height: 36px;\n  }\n  \n  .app-nav-grid {\n    width: 16px;\n    height: 16px;\n  }\n  \n  .nav-dot {\n    width: 3px;\n    height: 3px;\n  }\n}\n\n/* Dark mode support */\n@media (prefers-color-scheme: dark) {\n  .app-nav-dropdown {\n    background: #2d3748;\n    border-color: #4a5568;\n    color: #e2e8f0;\n  }\n  \n  .app-nav-header {\n    background: #1a202c;\n    border-bottom-color: #4a5568;\n  }\n  \n  .app-nav-header h3 {\n    color: #e2e8f0;\n  }\n  \n  .app-nav-item:hover {\n    background-color: #4a5568;\n  }\n  \n  .app-nav-item.current {\n    background-color: #2b6cb0;\n    border-color: #3182ce;\n  }\n  \n  .app-name {\n    color: #e2e8f0;\n  }\n  \n  .app-description {\n    color: #a0aec0;\n  }\n  \n  .app-nav-footer {\n    background: #1a202c;\n    border-top-color: #4a5568;\n  }\n  \n  .app-nav-footer small {\n    color: #a0aec0;\n  }\n  \n  .nav-dot {\n    background-color: #a0aec0;\n  }\n  \n  .app-nav-button:hover .nav-dot {\n    background-color: #e2e8f0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
